import type { ParticipantTaskTemplate } from '@piccolohealth/pbs-common';
import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteParticipantTaskTemplateMutation } from '../../../graphql/hooks/useDeleteParticipantTaskTemplateMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  participantTaskTemplate: ParticipantTaskTemplate;
}

export const ParticipantTaskTemplateDeleteModal = createModal<Props>((props) => {
  const { participantTaskTemplate, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantTaskTemplateMutation();

  const onDeletePrime = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantTaskTemplateId: participantTaskTemplate.id,
      })
      .then(() => {
        successToast('Task template deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting task template: ${err.message}`);
      });
  }, [mutation, organization.id, participantTaskTemplate.id, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this task template?'
      confirmation={{ level: 'Level2', confirm: participantTaskTemplate.name }}
      isLoading={mutation.isLoading}
      onDelete={onDeletePrime}
    />
  );
});
